<template>
  <div id="app" style="margin-top:0; margin-bottom: 60px;">
    <!--v-app id="inspire"-->
    <v-progress-linear :indeterminate="loading" :active="loading"></v-progress-linear>

      <div id="e3" style="max-width:400px; margin:auto;" class="grey lighten-3">
        <v-card>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12>
                <v-img :src="svg1"></v-img>
              </v-flex>
              <v-flex xs12>
                <v-img :src="svg2"></v-img>
              </v-flex>
              <v-flex xs12>              
                <v-alert :value="true" color="white" style="color:black;font-size:15px;text-align:left;border-width:0">
                  TWINS CUPID&reg;にセッティングされているツインズダイヤモンドは、世界でも最高峰の研磨技術を持った「株式会社ホープインターナショナル」で生み出されています。
                  ホープインターナショナルは、日本企業ならではの優れた生産管理体制を取り入れ、原石の状態から仕上がるまで、どういった工程を辿って、”だれ”が”いつ”研摩したかまでも把握できるよう、厳密に管理されています。<nav></nav>
                  「DIAMOND JOURNEY REPORT」は、厳密に管理されたダイヤモンドが原石からどのように生み出されたのかをいつでもWEBで確認できるオプションサービスです。
                </v-alert>  
              </v-flex>
              <v-flex xs12>
                <v-img :src="svgM3"></v-img>
              </v-flex>
              <v-flex xs12>
                <v-alert :value="true" color="white" style="color:Red;font-size:15x;text-align:left;border-width:0">
                  ※TWINS DIAMOND JOURNEY REPORTは有料オプションサービスです。ご成約後のご変更は承りかねますので予めご了承ください。
                </v-alert>  
              </v-flex>
              <v-flex xs12 style="background-color:#EEEEEE">
                <v-img :src="svg4"></v-img>
              </v-flex>
              <v-flex xs12 style="background-color:#EEEEEE">
                <v-img :src="svg5"></v-img>
              </v-flex>

              <v-flex xs12>
                <v-card class="elevation-10">
                  <v-card-text>
                    <v-form>
                      <v-text-field label="Serial No.1" box outline v-model="info.serial1" ref="serial1">                        
                      </v-text-field>
                      <v-text-field label="Serial No.2" box outline v-model="info.serial2">                        
                      </v-text-field>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-flex justify-center>
                    <v-btn color="info" @click="show" large>参照する</v-btn>
                    </v-flex>
                  </v-card-actions>
                  <v-alert :value="alert" color="error" style="height:24px">
                    【Serial No】をご確認の上再度ご入力ください。
                  </v-alert>
                </v-card>
              </v-flex>
              <v-flex xs12 style="height:40px;text-align:center">
                    動作に関するお問い合わせは<a href="http://abe-j.co.jp/">こちら</a>にお願いします。<br>
                    <a href="http://twinscupid.jp/index.php">TWINS CUPID HP</a>
              </v-flex>

            </v-layout>
          </v-container>
        </v-card>
      </div>
    <!--/v-app-->
  </div>
</template>


<script>
import MobileIs from 'ismobilejs';
import firebase from '../firebase.js';

import img1 from "@/assets/svg3/1themeimage.svg";
import img2 from "@/assets/svg3/2themetitle.svg";
import img3 from "@/assets/svg3/3explain.svg";
import img4 from "@/assets/svg3/4webmobile.svg";
import img5 from "@/assets/svg3/5login.svg";
import imgM3 from "@/assets/svg3/mprocess.svg";


export default {
  data() {
    return {
      svg1: img1,
      svg2: img2,
      svg3: img3,
      svg4: img4,
      svg5: img5,
      svgM3: imgM3,
      loading: false,
      info: {
        serial1: "",
        serial2: ""
      },
      catalog:null,
      alert:true,
    };
  },
  created(){
    this.init();
    this.checkMobile();
  },
  computed:{
  },
  methods: {
    checkMobile(){
      if(!MobileIs.phone){
        this.$router.push({ name: 'guest' });
      }
    },
    init(){
      this.alert = false;
    },
    show(){
      var str1 = this.info.serial1.trim();
        var str2 = this.info.serial2.trim();
        if(( 0 < str1.length && str1.length < 12 ) && ( 0<str2.length && str2.length < 12)){
          this.getCatalog(str1,str2).then(doc=>{
            if( doc ){
              this.$store.dispatch('setViewParams', doc);
              this.$router.push({ name: 'view' }); 
            } else {
              this.$refs.serial1.focus();
              this.alert = true;
            }
          });
        }
    },

    getCatalog(serial1,serial2){
      var promise = firebase.checkSerials(serial1,serial2);
      var res = promise.then(function(doc){
        if(doc.length > 0){
            var docItem = {
                key: doc[0].id,
                serial1: doc[0].serial1,
                serial2: doc[0].serial2,
                file1: doc[0].file1,
                file2: doc[0].file2,
                url1: doc[0].url1,
                url2: doc[0].url2,
                memo: doc[0].memo,
                createdt: doc[0].createdt,
                valid: doc[0].valid
            };
            return (docItem);
          }
      });
      return res;
    },
  }
};
</script>

<style>
#styled-input {
  height: 25px;
  font-size: 12pt;
}
.styled-input label[for] {
  height: 25px;
  font-size: 12pt;
}
</style>
